import { Col, LogoIcon, LogoImage, Row, theme } from '@/components';
import type { FC } from 'react';
import { useNavigate } from 'react-router';

type Props = {
  collapsed?: boolean;
  isPopupWindow?: boolean;
};

export const ServiceLogo: FC<Props> = ({ collapsed, isPopupWindow }) => {
  const { token } = theme.useToken();

  const navigate = useNavigate();
  const onClick = () => {
    navigate('/');
  };

  return (
    <Row
      style={{
        borderBottom: isPopupWindow
          ? undefined
          : `1px solid ${token.colorFill}`,
        height: isPopupWindow ? 48 : 80,
      }}
      align="middle"
      justify="center"
    >
      <Col>
        {collapsed ? (
          <LogoIcon onClick={isPopupWindow ? undefined : onClick} />
        ) : (
          <LogoImage onClick={isPopupWindow ? undefined : onClick} />
        )}
      </Col>
    </Row>
  );
};
